import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import moment from 'moment';
import { MONTHS } from '../../constants-and-enums/months';
import { Subscription } from 'rxjs';

@Component({
    standalone: false,
    selector: 'app-month-and-year-picker',
    templateUrl: './month-and-year-picker.component.html',
    styleUrls: ['./month-and-year-picker.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MonthAndYearPickerComponent implements OnInit, OnDestroy {
    @Input() yearsInThePast = 5;
    @Input() yearsInTheFuture = 5;
    @Input() invalid = false;

    @Output() valueChanges = new EventEmitter<{ month?: number; year?: number }>();

    dateForm = new FormGroup({
        month: new FormControl(new Date().getMonth(), [Validators.required]),
        year: new FormControl(new Date().getFullYear(), [Validators.required])
    });

    months = MONTHS;

    formSubscription: Subscription;

    ngOnInit(): void {
        this.formSubscription = this.dateForm.valueChanges.subscribe(() => {
            this.valueChanges.emit(this.dateForm.value);
        });
    }

    ngOnDestroy(): void {
        this.formSubscription?.unsubscribe();
    }

    get selectableYears(): number[] {
        const currentYear = new Date().getFullYear();
        const fromYear = currentYear - this.yearsInThePast;
        const toYear = currentYear + this.yearsInTheFuture;
        const numberOfYears = toYear - fromYear + 1;

        return [...Array(numberOfYears).keys()].map((i) => i + fromYear);
    }

    getWithDayOfMonth(day: number): Date | null {
        const { month, year } = this.dateForm.value;
        if (month && year) {
            const firstDay = moment({ year, month, day });
            return firstDay.toDate();
        }

        return null;
    }
}
